<template>
  <div class="verval">
    <v-card flat>
      <v-card-text>
        <h4 class="black--text">Daftar Laporan Pelaksanaan IHT Sekolah</h4>
        <v-divider class="my-2" />
        <base-table-header :btnAdd="$allow('psp-monev-dinas.create')" @add="onAdd" @reload="onReload">
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              Jumlah Data <span class="blue--text font-weight-medium">{{ total }}</span>
            </div>
          </template>
        </base-table-header>
        <v-divider />
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="fetchData"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-row no-gutters>
                    <v-col cols="12" md="4">
                      <v-list-item class="px-0">
                        <v-list-item-avatar color="blue">
                          <v-icon dark>mdi-hospital-building</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content class="py-0 px-1">
                          <p class="caption grey--text">
                            Nama Sekolah
                          </p>
                          <span class="body-1">
                            <strong>
                              {{ $getDeepObj(item, 'sekolah.data.nama') || '-' }}
                            </strong>
                          </span>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Nama Kepala Sekolah </small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            {{ $getDeepObj(item, 'psp_diklat_sekolah.data.ptk_kasek.data.nama') || '-' }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Pelaksanaan IHT</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            {{ $localDate($getDeepObj(item, 'tgl_monev')) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Status Laporan</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-chip dark small :color="isLengkap(item) ? 'success' : 'warning'">
                              {{ isLengkap(item) ? 'Sudah Lengkap' : 'Belum Lengkap' }}
                            </v-chip>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-list-item class="px-0">
                        <v-list-item-content class="py-0">
                          <v-list-item-title>
                            <v-label color="caption"><small>Aksi</small></v-label>
                          </v-list-item-title>
                          <v-list-item-subtitle class="link black--text body-2">
                            <v-btn
                              v-if="$allow('psp-monev-dinas.update')"
                              depressed
                              small
                              dark
                              block
                              :color="isLengkap(item) ? 'primary' : 'orange'"
                              @click="onEdit(item)"
                            >
                              {{ isLengkap(item) ? 'Lihat Detail' : 'Edit Laporan' }}
                            </v-btn>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-list-item-content>
                <v-list-item-action-text>
                  <template v-if="$allow('psp-monev-dinas.delete')">
                    <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                  </template>
                  <template v-else>
                    <div style="min-width: 40px">&nbsp;</div>
                  </template>
                </v-list-item-action-text>
              </v-list-item>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full ref="modal" title="Laporan Pelaksanaan IHT Sekolah" @save="onSave">
      <form-upt ref="formulir" :initValue="formulir.init"></form-upt>
    </base-modal-full>
  </div>
</template>

<script>
import list from '@mixins/list';
import { mapActions } from 'vuex';
import actions from './actions';
import FormUpt from '../formulir/Upt';
export default {
  name: 'Index',
  mixins: [list],
  components: { FormUpt },
  data() {
    return {
      actions: actions,
      formulir: {},
    };
  },
  computed: {},
  created() {},
  methods: {
    ...mapActions('diklatUpt', {
      fetch: 'fetch',
      getDetail: 'getDetail',
      create: 'create',
      update: 'update',
      delete: 'delete',
    }),

    isLengkap(item) {
      const laporan = this.$getDeepObj(item, 'status_laporan') || {};
      let status = true;

      Object.keys(laporan).forEach((i) => {
        if (!laporan[i]) {
          status = false;
          return;
        }
      });
      return Object.keys(laporan).length > 0 ? status : false;
    },

    onAdd() {
      this.$set(this.formulir, 'id', null);

      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', null);
      });
    },

    async onEdit(item) {
      const data = await this.getDetail({ id: item.psp_monev_dinas_id }).then(({ data }) => data);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(
          this.formulir,
          'init',
          Object.assign({}, data, { psp_diklat_sekolah: item.psp_diklat_sekolah || {} })
        );
      });
    },

    onSave() {
      const item = this.$refs.formulir.getValue();
      const id = item.id || null;
      const params = item.params || {};
      const formData = new FormData();

      if (params) {
        for (let key in params) {
          formData.append(key, params[key]);
        }
      }

      this[id ? 'update' : 'create']({ id: id, params: formData })
        .then(() => {
          this.$success(`Data laporan UPT berhasil di ${id ? 'perbarui' : 'tambahkan'}`);
          this.$refs.modal.close();
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    onHapus(item) {
      this.$confirm(
        `Apakah anda yakin ingin menhapus laporan upt dari sekolah <b>${this.$getDeepObj(
          item,
          'sekolah.data.nama'
        )}</b>`,
        'Hapus UPT',
        {
          tipe: 'error',
          data: [],
        }
      ).then(() => {
        this.delete({ id: item.psp_monev_dinas_id }).then(() => {
          this.$success('Data laporan UPT berhasil di hapus');
          this.onReload();
        });
      });
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
